import React from "react";
import { isVersionAGreaterThanB } from "../../utils/version-util";
import { useSharedSelector } from "../../store/SharedProvider";
import { selectRobotRswSoftwareVersion } from "../../store/robot-configurations/robot-configurations-selectors";

const RobotVersionControlledWrapper: React.FC<{
  minVersion?: string; // the minimum version the robot must have to see content
  maxVersion?: string; // versions must be smaller than this to see content (is blocking)
  forceAllow?: boolean;
  forceHide?: boolean;
  children: React.ReactElement;
}> = ({ minVersion, maxVersion, forceAllow, forceHide, children }) => {
  const robotVersion = useSharedSelector((state) => selectRobotRswSoftwareVersion(state));

  if (
    forceAllow !== true &&
    (forceHide ||
      robotVersion == null ||
      (minVersion != null && isVersionAGreaterThanB(minVersion, robotVersion)) ||
      (maxVersion != null && !isVersionAGreaterThanB(maxVersion, robotVersion)))
  ) {
    return null;
  }
  return children;
};

export default RobotVersionControlledWrapper;
